

var util = require('../../util/property-util');
var arrayUtil = require('../../util/array-util');
var graphUtil = require('../../util/graph-util');

module.exports = /*@ngInject*/ ["ReferenceAreaService", "$q", "$log", "$compile", "$timeout", function GoogleMapsFactory(ReferenceAreaService, $q, $log, $compile, $timeout) {
    var factory = {};
    var defaultLegend = [
        {
          name: "shadowzones", 
          style: {
            'background-color': "rgb(180, 110, 246)"
          }, 
          visible: true
        },
        {
          name: "waypoints", 
          style: {
            'background-color': "#08BBCF"
          }, 
          visible: true
        },
        { 
          name: "drawings", 
          style: {
            'background-color': "#ff8a8a"
          }, 
          visible: true
        },
        {
          name: "depots",
          style: {
            'background-color': "#1fcf32"
          }, 
          visible: true
        }
      ];

    factory.createMap = function (mapDiv) {
        var styles = [{
            featureType: "transit.line",
            elementType: "geometry",
            stylers: [{color: "#404040"}, {weight: 3}]
        }];

        var styledMap = new google.maps.StyledMapType(styles,
            {name: "Railroad Overlay"});

        return $timeout(function () {
            var map = new google.maps.Map(
                document.getElementById(mapDiv),
                {
                    zoom: 15,
                    mapTypeControlOptions: {
                        mapTypeIds: [google.maps.MapTypeId.ROADMAP, google.maps.MapTypeId.HYBRID]
                    },
                    fullscreenControl: false
                });
            map.mapTypes.set('railroad_overlay', styledMap);
            map.setMapTypeId('railroad_overlay');

            return map;
        });
    };

    factory.getDepotZones = function (projectId) {
        var deferred = $q.defer();

        ReferenceAreaService.depots().query({"projectId": projectId}).$promise.then(function (data) {
            deferred.resolve(processReferenceAreas(arrayUtil.getFirstInList(defaultLegend, "name", "depots").style["background-color"], data));
        });

        return deferred.promise;
    };

    factory.getWaypoints = function (projectId) {
        var deferred = $q.defer();

        ReferenceAreaService.waypoint().query({"projectId": projectId}).$promise.then(function (data) {
            var processedArea = processReferenceAreas(arrayUtil.getFirstInList(defaultLegend, "name", "waypoints").style["background-color"], data);
            deferred.resolve(processedArea);
        });

        return deferred.promise;
    };

    factory.getCustomReferenceAreas = function (projectId, clickFunction, referenceAreaId) {
        var deferred = $q.defer();
        var referenceAreasQueryData = referenceAreaId ? 
        ReferenceAreaService.customReferenceAreas(referenceAreaId).query({"projectId": projectId}).$promise : ReferenceAreaService.customReferenceAreas().query({"projectId": projectId}).$promise;
        var referenceAreas = referenceAreasQueryData.then(function (data) {
            var processedAreas = processReferenceAreas(arrayUtil.getFirstInList(defaultLegend, "name", "drawings").style["background-color"], data);
            if (util.isDefined(clickFunction)) {
                processedAreas.forEach(function (polygon) {
                    google.maps.event.addListener(polygon, "click", function (event) {
                        clickFunction(polygon, event);
                    });
                });
            }

            return processedAreas;
        });

        deferred.resolve(referenceAreas);
        return deferred.promise;
    };


    function processReferenceAreas(color, data) {
        var referenceAreas = [];
        data.forEach(function (refArea) {
            var refAreaLegend = defaultLegend.find(legend => legend.name.toUpperCase().includes(refArea.type)) || defaultLegend[2];
            color = refAreaLegend ? refAreaLegend.style["background-color"] : color;
            var referenceArea = createReferenceArea(refArea, color);
            referenceArea.area = refArea.area;
            referenceAreas.push(referenceArea);
        });
        return referenceAreas;

        function createReferenceArea(sz, color) {
            var path = createPathFromResponseArea(sz.area.positions);
            return createReferenceAreaObject(sz, path, color);
        }
    }

    /**
     * Adds an array of google maps object from the map
     * @param map       google map
     * @param objects   array of google map objects
     */
    factory.addObjectsToMap = function (map, objects) {
        if (util.isDefined(objects) && objects.length !== 0) {
            objects.forEach(function (obj) {
                obj.setMap(map);
            });
        }
    };
    /**
     * Removes any google maps object from the map
     * @param objects   array of google map objects
     */
    factory.removeObjectsFromMap = function (objects) {
        if (util.isDefined(objects) && objects.length !== 0) {
            objects.forEach(function (obj) {
                if (obj.infowindow) {
                    obj.infowindow.setMap(null);
                }
                obj.setMap(null);
            });
        }
    };

    /**
     * Add an item (that is defined in the defaultLegend) to the current legend
     * @param name          name of the item to add to the legend
     * @param onclick       function to execute on-click
     */
    factory.getLegendItem = function (name, onclick) {
        var item = arrayUtil.getFirstInList(defaultLegend, "name", name);
        if (util.isDefined(item)) {
            return item;
        } else {
            return this.getCustomToLegendItem(name, graphUtil.getRandomColor());
        }
    };
    /**
     * Add a custom item to the legend
     * @param name      display name
     * @param color     color for the legend item
     */
    factory.getCustomToLegendItem = function (name, color) {
        return {"name": name, "style": {"background-color": color}, visible: true};
    };

    /**
     * Adds the drawing toolbox to the map
     * @param map {google.maps.Map}
     * @param overlayCompleteFunction
     * @param visible drawing control visibility
     * @returns {google.maps.drawing.DrawingManager}
     */
    factory.addDrawingOptions = function (map, overlayCompleteFunction, visible) {
        var defaultOverlayCompleteFunction = function (event) {
            $log.log("OverlayComplete event: Using default function (does nothing)");
        };

        var drawingManager = new google.maps.drawing.DrawingManager({
            drawingMode: null,
            drawingControl: visible,
            drawingControlOptions: {
                position: google.maps.ControlPosition.TOP_CENTER,
                drawingModes: [
                    google.maps.drawing.OverlayType.POLYGON
                ]
            },
            polygonOptions: {
                strokeOpactity: 0.8,
                strokeColor: '#FF5757',
                fillColor: '#FF5757',
                fillOpacity: 0.25,
                strokeWeight: 2,
                clickable: true,
                editable: false,
                zIndex: 1
            }
        });

        overlayCompleteFunction = util.isDefined(overlayCompleteFunction) ? overlayCompleteFunction : defaultOverlayCompleteFunction;
        google.maps.event.addListener(drawingManager, 'polygoncomplete', overlayCompleteFunction);

        return drawingManager;
    };
    /**
     * Resets the selected drawing tool to the drag-hand
     * @param drawingManager    {google.maps.drawing.DrawingManager}
     */
    factory.resetDrawingTool = function (drawingManager) {
        if (util.isDefined(drawingManager)) {
            drawingManager.setDrawingMode(null);
        }
    };

    factory.customReferenceAreaCRUD = function (referenceArea, projectId) {



        var errorMsg;
        return {
            save: function () {
                if (util.isDefined(errorMsg)) {
                    return $q.reject(errorMsg);
                }
                // creates a new custom reference area in the dbs
                return ReferenceAreaService.customReferenceAreas().save({projectId: projectId}, [referenceArea]).$promise;
                
            },
            update: function () {
                if (util.isDefined(errorMsg)) {
                    return $q.reject(errorMsg);
                }
                // update this existing custom reference area in the dbs
                return ReferenceAreaService.customReferenceArea().save({
                        projectId: projectId,
                        id: referenceArea.id
                    }, referenceArea,
                    function (referenceAreaResponse) {
                        return referenceAreaResponse;
                    },
                    function (errormsg) {
                        return errormsg;
                    }).$promise;
            },
            delete: function () {
                // delete this custom reference area from the dbs
                return ReferenceAreaService.customReferenceArea().delete({
                        projectId: projectId,
                        id: referenceArea.id,
                        type: referenceArea.type
                    },
                    function (msg) {
                    },
                    function (errormsg) {
                        return errormsg.statusText;
                    }).$promise;
            }
        };
    };

    var createReferenceAreaRequestBody = function (referenceArea, projectId) {
        var refAreaRequestBody = {};
        refAreaRequestBody.projectId = projectId;
        refAreaRequestBody.area = factory.parsePathToString(referenceArea.getPath());
        refAreaRequestBody.description = util.isDefined(referenceArea.description) ? referenceArea.description : "";
        refAreaRequestBody.abbreviation = referenceArea.abbreviation;
        refAreaRequestBody.type = referenceArea.type;
        refAreaRequestBody.name = referenceArea.name;
        refAreaRequestBody.id = referenceArea.id;
        if (util.isDefined(referenceArea.id)) {
            refAreaRequestBody.id = referenceArea.id;
        }

        return refAreaRequestBody;
    };

    var verifyReferenceArea = function (referenceArea, requestBody, projectId) {
        var path = referenceArea.getPath();
        if (util.isDefined(path)) {
            if (path.length < 3) {
                return "An area should contain atleast three data points";
            }
        } else {
            return "No area found";
        }
        if (!util.isDefined(projectId)) {
            return "No projectId defined";
        }
        return undefined;
    };

    /**
     * Creates and returns a copy of the polygon's path
     * @param polygon {google.maps.Polygon} to extract the path from
     * @returns {Array} an array of {google.maps.LatLng} coordinates
     */
    factory.getPathCopyFromPolygon = function (polygon) {
        var pathCopy = [];
        polygon.getPath().forEach(function (latLng) {
            pathCopy.push(new google.maps.LatLng(latLng.lat(), latLng.lng()));
        });
        return pathCopy;
    };

    /**
     * Parses a google maps path to
     * @param path
     */
    factory.parsePathToString = function (path) {
        var pathString = "";
        path.forEach(function (latLng) {
            pathString += latLng.lat() + "," + latLng.lng() + " ";
        });
        return pathString;
    };

    /**
     * creates an array of LatLng coordinates for a given area
     * @param area      array of positions {latitude, longitude, altitude, valid}
     * @returns {Array} array of LatLng coordinates
     */
    function createPathFromResponseArea(area) {
        var path = [];
        area.forEach(function (pos) {
            path.push(new google.maps.LatLng(pos.latitude, pos.longitude));
        });
        return path;
    }

    /**
     * Creates the shadowZone object (polygon)
     * @param refAreaData  reference area
     * @param path  array of LatLng coordinates (points that make up the polygon)
     * @param color color
     * @returns {Window.google.maps.Polygon}
     */
    function createReferenceAreaObject(refAreaData, path, color) {
        var referenceAreaPolygon = new google.maps.Polygon({
            paths: path,
            strokeColor: color,
            strokeOpacity: 0.8,
            strokeWeight: 2,
            fillColor: color,
            fillOpacity: 0.25
        });

        referenceAreaPolygon.id = refAreaData.id;
        referenceAreaPolygon.description = refAreaData.description;
        referenceAreaPolygon.projectId = refAreaData.projectId;
        referenceAreaPolygon.abbreviation = refAreaData.abbreviation;
        referenceAreaPolygon.type = refAreaData.type;
        referenceAreaPolygon.name = refAreaData.name;
        return referenceAreaPolygon;
    }

    return factory;
}];